// import { AddButton } from '../forms'
import { Item } from './card.component'
import ControlPointIcon from '@mui/icons-material/ControlPoint'

import { useStyles } from '../styles'
import { IRedirectURLRespDto } from 'src/types/redirect-url.type'
import { Button } from '@mui/material'
import { useState } from 'react'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { RedirectURLModal } from '../modal/create-redirect-url.modal'

interface IProps {
  items: IRedirectURLRespDto[]
}

export const RedirectURLsGrid = ({ items }: IProps) => {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  return (
    <>
      <Button
        sx={{ marginLeft: 'auto', marginBottom: 2 }}
        color={'primary'}
        size={'medium'}
        variant="contained"
        startIcon={<ControlPointIcon />}
        onClick={() => setModalOpen(true)}
      >
        <HelperWrapper t="button-add-new-text" />
      </Button>
      <div className={classes.cardsWrapper}>
        {items.map((item) => (
          <Item key={item.id} item={item} />
        ))}
      </div>
      <RedirectURLModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </>
  )
}
